import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "family-step-background",
  "use": "family-step-background-usage",
  "viewBox": "0 0 750 1056",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 750 1056\" id=\"family-step-background\"><path d=\"M1027 1178H-298V662.5C-298 296.611-1.389 0 364.5 0S1027 296.611 1027 662.5V1178z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol